import { all } from 'redux-saga/effects';

import { watchRequestRemoveServerSideCookie, watchRequestSetServerSideCookie } from './auth/sagas';
import {
	watchRequestCreateLayer,
	watchRequestCreateSource,
	watchRequestLayers,
	watchRequestRemoveLayer,
	watchRequestRemoveSource,
	watchRequestSources,
	watchRequestUpdateLayer,
	watchRequestUpdateSource,
	watchRequestUpdateTileserver
} from './map_features/sagas';

export default function* sagas() {
	yield all([
		watchRequestCreateLayer(),
		watchRequestCreateSource(),
		watchRequestLayers(),
		watchRequestRemoveLayer(),
		watchRequestRemoveServerSideCookie(),
		watchRequestRemoveSource(),
		watchRequestSetServerSideCookie(),
		watchRequestSources(),
		watchRequestUpdateLayer(),
		watchRequestUpdateSource(),
		watchRequestUpdateTileserver()
	]);
}
